export default __webpack_public_path__ + "static/media/warning-sign.6689b9df.svg";